var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconClip = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C11.7614 0 14 2.23858 14 5V17C14 20.866 10.866 24 7 24C3.13401 24 0 20.866 0 17V9H2V17C2 19.7614 4.23858 22 7 22C9.76142 22 12 19.7614 12 17V5C12 3.34315 10.6569 2 9 2C7.34315 2 6 3.34315 6 5V17C6 17.5523 6.44772 18 7 18C7.55228 18 8 17.5523 8 17V6H10V17C10 18.6569 8.65685 20 7 20C5.34315 20 4 18.6569 4 17V5C4 2.23858 6.23858 0 9 0Z",
    fill: "current"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconClip, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-clip.c51cbe72.svg";
export { ForwardRef as ReactComponent };